import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import Router from './router'
import { REACT_DYNATRACE_SCRIPT_URL, REACT_DYNATRACE_DATA_CONFIG } from './config/terraformConfig'
import { setupGlobalErrorHandlers } from './utils/errorLogger'
import './index.scss'

// Load Dynatrace before React starts
const dynatraceScriptUrl = REACT_DYNATRACE_SCRIPT_URL;
const script = document.createElement("script");
script.src = dynatraceScriptUrl;
script.async = true;
script.dataset.dtconfig = REACT_DYNATRACE_DATA_CONFIG;
script.crossOrigin = "anonymous";
document.head.appendChild(script);

setupGlobalErrorHandlers();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Router />
  </StrictMode>,
)
